module.exports = __webpack_public_path__ + "img/QRCode_followUs.440fd921.png";